import React from 'react'

export function px2rem(val: number): string {
  return val / 100 + 'rem'
}

export function rem2px(val: string): number {
  return parseFloat(val) * 100
}

export function thirdPackagePx2px(px: number) {
  if (typeof window === 'undefined') {
    return px
  }
  return (document.documentElement.clientWidth / 375) * px
}

export function handleStyle(styleObj: React.CSSProperties, keys?: string[]): React.CSSProperties {
  const obj = { ...styleObj }
  if (keys) {
    keys.forEach((key) => {
      obj[key] = px2rem(obj[key])
    })
  } else {
    Object.keys(obj).forEach((key) => {
      obj[key] = px2rem(obj[key])
    })
  }
  return obj
}
